import React from 'react'
import { authRoles } from '../../auth/authRoles'

const AdminDataSetupRoute = [
    // {
    //     path: '/adminDataSetup',
    //     component: React.lazy(() => import('./Data_Setup/Setup')),
    //     // auth: authRoles.dashboard,
    // },


    // data setups
    {
        path: '/adminPropertySetup',
        component: React.lazy(() => import('./Data_Setup/Pages/PropertySetup')),
        auth: authRoles.super_admin,
    },
    {
        path: '/adminSetup/propertyTypeItem/:id',
        component: React.lazy(() => import('./Data_Setup/Pages/AddPropertyTypeItem')),
        auth: authRoles.super_admin,
    },
    {
        path: '/adminRoomSetup',
        component: React.lazy(() => import('./Data_Setup/Pages/RoomSetup')),
        auth: authRoles.super_admin,
    },
    {
        path: '/adminWellnessSetup/allWellness',
        component: React.lazy(() => import('./Data_Setup/Pages/AllWellessPackages')),
        auth: authRoles.super_admin,
    },
    {
        path: '/adminWellnessSetup/addSingleWellness',
        component: React.lazy(() => import('./Data_Setup/Pages/AddWellessPackages')),
        auth: authRoles.super_admin,
    },

    // category setups
    {
        path: '/adminCategorySetup',
        component: React.lazy(() => import('./Category_Setup/CategorySetup')),
        auth: authRoles.super_admin,
    },

    // Wellness Packages 
    {
        path: '/adminWellnessPackagesSetup',
        component: React.lazy(() => import('./Wellness_Packages/WellnessPackagesSetup')),
        auth: authRoles.super_admin,
    },
    {
        path: '/adminWellnessPackages/addWellnessPackage',
        component: React.lazy(() => import('./Wellness_Packages/AddWelnessPackages')),
        auth: authRoles.super_admin,
    },
    {
        path: '/adminWellnessPackages/singleView/:id',
        component: React.lazy(() => import('./Wellness_Packages/WelnessPackageSingleView')),
        auth: authRoles.super_admin,
    },
    {
        path: '/adminRoomTypeSetup',
        component: React.lazy(() => import('./RoomType_Setup/RoomTypeSetup')),
        auth: authRoles.super_admin,
    },
    {
        path: '/adminBedTypeSetup',
        component: React.lazy(() => import('./BedType_Setup/BedTypeSetup')),
        auth: authRoles.super_admin,
    },

    // meal planes
    {
        path: '/adminMealPalnesSetup',
        component: React.lazy(() => import('./MealPlane_Setup/MealPaneSetup')),
        auth: authRoles.super_admin,
    },

    // hotels
    {
        path: '/admin_all_holels',
        component: React.lazy(() => import('./Hotels/All')),
        auth: authRoles.super_admin,
    },
    {
        path: '/admin_holels_signle_view/:id',
        component: React.lazy(() => import('./Hotels/Tabs/Single_View')),
        auth: authRoles.super_admin,
    },

        {
        path: '/admin/discounts',
        component: React.lazy(() => import('./Discount/Discount')),
        auth: authRoles.super_admin,
    },

    // agent 
    {
        path: '/admin/agent',
        component: React.lazy(() => import('./Agent/All')),
        auth: authRoles.super_admin,
    },
    {
        path: '/admin/agent_commission',
        component: React.lazy(() => import('./AgentCommision/AgentCommision')),
        auth: authRoles.super_admin,
    },

  
]

export default AdminDataSetupRoute
